import React from 'react'

const DeviceImages = (props) => {

  switch ( props.graphic ) {
    case 'desktop':
    return (
      <svg className="deviceImg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300"><title>desktop</title><g id="desktop"><path id="fill" d="M254.39,206.64V74.05a12,12,0,0,0-12-12H57.45a12,12,0,0,0-12,12V206.64H26.92v20.65A10.66,10.66,0,0,0,37.58,238H262.42a10.66,10.66,0,0,0,10.66-10.66V206.64ZM59.45,76.05H240.39V206.64H59.45Z" fill="#fff"/><path id="lines" d="M254.39,206.64H45.45V74.05a12,12,0,0,1,12-12H242.39a12,12,0,0,1,12,12Zm18.69,20.65V206.64H26.92v20.65A10.66,10.66,0,0,0,37.58,238H262.42A10.66,10.66,0,0,0,273.08,227.29ZM240.39,76.05H59.45V206.64H240.39ZM121.33,222.29h61.34" fill="none" stroke="#000" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="4"/></g></svg>
    )


    case 'tablet':
    return (
      <svg className="deviceImg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300"><title>tablet</title><g id="tablet"><path id="fill" d="M252.88,62H48.34a12,12,0,0,0-12,12V226a12,12,0,0,0,12,12H252.88a12,12,0,0,0,12-12V74A12,12,0,0,0,252.88,62ZM50,156a6,6,0,1,1,6-6A6,6,0,0,1,50,156ZM253.4,230.49H64.69v-161H253.4Z" fill="#fff"/><path id="lines" d="M252.88,238H48.34a12,12,0,0,1-12-12V74a12,12,0,0,1,12-12H252.88a12,12,0,0,1,12,12V226A12,12,0,0,1,252.88,238Zm.52-168.49H64.69v161H253.4ZM50,144a6,6,0,1,0,6,6A6,6,0,0,0,50,144Z" fill="none" stroke="#000" strokeMiterlimit="10" strokeWidth="4"/></g></svg>
    )


    case 'phone':
    return (
      <svg className="deviceImg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300"><title>phone</title><g id="phone"><path id="fill" d="M101,226a12,12,0,0,0,12,12h74a12,12,0,0,0,12-12V208.42H101Zm48.83-9.79a7,7,0,1,1-7,7A7,7,0,0,1,149.83,216.21ZM199,74v4.69H101V74a12,12,0,0,1,12-12h74A12,12,0,0,1,199,74Z" fill="#fff"/><path id="lines" d="M187,238H113a12,12,0,0,1-12-12V74a12,12,0,0,1,12-12h74a12,12,0,0,1,12,12V226A12,12,0,0,1,187,238Zm-86-29.58h98M101,78.69h98m-69.45-8.34h40.9M149.83,216.21a7,7,0,1,0,7,7A7,7,0,0,0,149.83,216.21Z" fill="none" stroke="#000" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="4"/></g></svg>
    )


    default:
    return (
      <svg className="deviceImg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300"><title>desktop</title><g id="desktop"><path id="fill" d="M254.39,206.64V74.05a12,12,0,0,0-12-12H57.45a12,12,0,0,0-12,12V206.64H26.92v20.65A10.66,10.66,0,0,0,37.58,238H262.42a10.66,10.66,0,0,0,10.66-10.66V206.64ZM59.45,76.05H240.39V206.64H59.45Z" fill="#fff"/><path id="lines" d="M254.39,206.64H45.45V74.05a12,12,0,0,1,12-12H242.39a12,12,0,0,1,12,12Zm18.69,20.65V206.64H26.92v20.65A10.66,10.66,0,0,0,37.58,238H262.42A10.66,10.66,0,0,0,273.08,227.29ZM240.39,76.05H59.45V206.64H240.39ZM121.33,222.29h61.34" fill="none" stroke="#000" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="4"/></g></svg>
    )



  }

}

export default DeviceImages
